import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Style from './Header.module.scss';

const Header = ({ isDropActive = false, isSameDay = false }) => {
  const {
    nft_activeHeader = 'Drop is open!',
    nft_sameDayHeader = 'Upcoming Drop',
    nft_upcomingHeader = 'Upcoming Drop',
  } = window.Language;
  let header = nft_upcomingHeader;
  if (isSameDay) header = nft_sameDayHeader;
  if (isDropActive) header = nft_activeHeader;
  return <h2 className={classnames(Style.header, isDropActive && Style.activeHeader)}>{header}</h2>;
};

Header.propTypes = {
  isDropActive: PropTypes.bool,
  isSameDay: PropTypes.bool,
};

export default Header;
